import React, { useMemo, useCallback } from 'react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { SingleSelectButtonGroup } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const AllSizesButtonGroup = () => {
  const [state, dispatch] = useProductDetailsPageContext();
  const { reportSelectEvent } = useSelectEvent();

  const currentSkuSize = useMemo(() => {
    return state.onRecommendedSizesTab
      ? state.recommendedSkuSizeLabel || ''
      : state.selectedSizeLabel || '';
  }, [
    state.onRecommendedSizesTab,
    state.recommendedSkuSizeLabel,
    state.selectedSizeLabel,
  ]);

  const handleSizeFilterClick = useCallback(
    sizeLabel => {
      reportSelectEvent({
        schema: 'product_select',
        name: 'size',
        action_name: 'size_select',
        external_product_id: `${state.externalProductId}`,
        size: sizeLabel,
        unique_color_id: state.selectedUniqueColorId,
        inseam: state.selectedInseamLabel,
        fit: null, // We don't currently track this
      });

      dispatch({ type: 'SIZE_SELECTED', payload: { sizeLabel } });
    },
    [
      reportSelectEvent,
      state.externalProductId,
      state.selectedUniqueColorId,
      state.selectedInseamLabel,
      dispatch,
    ],
  );

  const singleSelectButtonGroupOptions = useMemo(() => {
    return [...state.sizeOptions]
      .sort((a, b) => a.order - b.order)
      .map(size => {
        return {
          value: size.label,
          label: size.label,
          status: size.availability ? 'enabled' : 'unavailable',
          'aria-label': `Size ${size.label}${
            size.availability ? '' : ' - out of stock'
          }`,
        };
      });
  }, [state.sizeOptions]);

  return (
    <SingleSelectButtonGroup
      mb={1}
      mt={0.5}
      options={singleSelectButtonGroupOptions}
      value={currentSkuSize}
      name="sizes"
      onChange={selectedSizeValue => handleSizeFilterClick(selectedSizeValue)}
    />
  );
};

export default React.memo(AllSizesButtonGroup);
